var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_796)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5299 5.36781C22.5556 6.7618 22.5556 8.75029 22.5556 12.7273C22.5556 16.7043 22.5556 18.6928 21.5299 20.0867C21.1987 20.5369 20.7977 20.9329 20.3418 21.2599C18.9301 22.2727 16.9164 22.2727 12.8889 22.2727C8.86141 22.2727 6.84767 22.2727 5.43598 21.2599C4.98007 20.9329 4.57913 20.5369 4.24789 20.0867C3.22224 18.6928 3.22224 16.7043 3.22224 12.7273C3.22224 8.75029 3.22224 6.7618 4.24789 5.36781C4.57913 4.91761 4.98007 4.5217 5.43598 4.19461C6.84767 3.18182 8.86141 3.18182 12.8889 3.18182C16.9164 3.18182 18.9301 3.18182 20.3418 4.19461C20.7977 4.5217 21.1987 4.91761 21.5299 5.36781Z",
    fill: "#A6ACB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5299 5.36781C22.5556 6.7618 22.5556 8.75029 22.5556 12.7273C22.5556 16.7043 22.5556 18.6928 21.5299 20.0867C21.1987 20.5369 20.7977 20.9329 20.3418 21.2599C18.9301 22.2727 16.9164 22.2727 12.8889 22.2727C8.86141 22.2727 6.84767 22.2727 5.43598 21.2599C4.98007 20.9329 4.57913 20.5369 4.24789 20.0867C3.22224 18.6928 3.22224 16.7043 3.22224 12.7273C3.22224 8.75029 3.22224 6.7618 4.24789 5.36781C4.57913 4.91761 4.98007 4.5217 5.43598 4.19461C6.84767 3.18182 8.86141 3.18182 12.8889 3.18182C16.9164 3.18182 18.9301 3.18182 20.3418 4.19461C20.7977 4.5217 21.1987 4.91761 21.5299 5.36781Z",
    stroke: "url(#paint0_linear_1_796)",
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1811 9.04982C12.8651 8.74057 12.8628 8.23692 13.176 7.92489C13.4892 7.61286 13.9992 7.61062 14.3152 7.91987L15.8631 9.43477C16.439 9.99837 16.9193 10.4684 17.2618 10.8895C17.621 11.3312 17.8942 11.7953 17.9672 12.3608C17.9829 12.4825 17.9908 12.6049 17.9908 12.7273C17.9908 12.8497 17.9829 12.972 17.9672 13.0937C17.8942 13.6592 17.621 14.1234 17.2618 14.565C16.9193 14.9861 16.439 15.4562 15.8631 16.0198L14.3152 17.5347C13.9992 17.8439 13.4892 17.8417 13.176 17.5297C12.8628 17.2176 12.8651 16.714 13.1811 16.4047L14.6959 14.9222C15.3134 14.3178 15.7273 13.9111 16.0056 13.5689C16.0184 13.5532 16.0307 13.5378 16.0426 13.5227H8.59261C8.14771 13.5227 7.78705 13.1666 7.78705 12.7273C7.78705 12.288 8.14771 11.9318 8.59261 11.9318H16.0426C16.0307 11.9167 16.0184 11.9014 16.0056 11.8857C15.7273 11.5435 15.3134 11.1367 14.6959 10.5324L13.1811 9.04982Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_796",
    x: -21.2778,
    y: -21.3182,
    width: 68.3333,
    height: 68.0909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_796",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_796",
    x1: 22.5556,
    y1: 3.18182,
    x2: 3.45626,
    y2: 22.5041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_796",
    x1: 12.803,
    y1: 19.9117,
    x2: -1.10557,
    y2: 6.10479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSquare);
export default __webpack_public_path__ + "static/media/right-square.f29c98273d554fbdda1dd761a8e68608.svg";
export { ForwardRef as ReactComponent };